define('apps/course-intro/views/regions/modules/module-grid',[
    'apps/course-intro/views/items/module'
], function (ModuleView) {
    "use strict";

    return Mn.CollectionView.extend({

        "tagName": "ul",

        "className": "module-grid",

        "childView": ModuleView,

        "childViewOptions": function (model) {
            return {
                "itemIndex": this.collection.indexOf(model),
                "levelGuid": this.collection.levelGuid,
                "levelNum": this.collection.levelNum
            };
        },

        "onShow": function () {
            $(document).on('keydown', null, {"view": this}, this.captureUnlockKeyCombo);
        },

        "captureUnlockKeyCombo": function (event) {
            var keyChar = String.fromCharCode(event.which),
                view = event.data.view;

            if (event.ctrlKey && event.shiftKey && keyChar.toLowerCase() === 'u') {
                view.unlockAllModules();
            }
        },

        "unlockAllModules": function () {
            this.collection.each(function (module) {
                if (!module.get('isUnlocked')) {
                    module.set('isUnlocked', true);
                }
            });
        },

        "onDestroy": function () {
            $(document).off('keydown', this.captureUnlockKeyCombo);
        }
    });
});


